import * as React from 'react';

import assetUrl from 'mk/common/assetUrl';

import Img from './Img';

export enum StickerSize {
    Icon = 25,
    Small = 75,
    Big = 100,
}

interface OwnProps {
    className?: string;
    id: number;
    size: StickerSize;

    /** If true, image is loaded only if it comes to viewport */
    lazy?: boolean;

    onClick?();
}

class Sticker extends React.Component<OwnProps> {
    public render() {
        const { className, id, size, lazy, onClick } = this.props;

        return (
            <Img
                className={className}
                src={assetUrl + 'img/photoblog/stickers/' + id + '.png'}
                width={size}
                height={size}
                onClick={onClick}
                lazy={lazy}
            />
        );
    }
}

export default Sticker;
